import { Outlet } from 'react-router-dom';

export const Borrower = () => {
	return <Outlet></Outlet>;
};
